import { PIEVE_MODEL_MAP, PIEVE_SENTINEL_MODELS } from '@shared/pieve/modelCatalog.js';
import { resolvePieveModelId } from '@shared/pieve/modelSelection.js';
import { DEFAULT_PIEVE_MODEL_ID } from '@shared/pieve/defaultModel.js';

const getModelOptionById = ({ modelId, includeHidden = true, advancedMode = false } = {}) => {
  const resolvedId = modelId || DEFAULT_PIEVE_MODEL_ID;
  const isSentinel = Boolean(PIEVE_SENTINEL_MODELS[resolvedId]);
  const config = isSentinel ? PIEVE_SENTINEL_MODELS[resolvedId] : PIEVE_MODEL_MAP[resolvedId];

  if (!config) {
    return null;
  }

  if (!includeHidden) {
    const showInBasic = config?.ui?.showInBasicComposer !== false;
    const showInAdvanced = config?.ui?.showInAdvancedComposer !== false;

    if (advancedMode && !showInAdvanced) {
      return null;
    }
    if (!advancedMode && !showInBasic) {
      return null;
    }
  }

  // Sentinel models have no provider identity of their own; runtime metadata comes
  // from their resolved target model.
  const targetConfig = isSentinel ? PIEVE_MODEL_MAP[resolvePieveModelId(resolvedId)] : config;

  return {
    value: resolvedId,
    label: config.label,
    provider: isSentinel ? null : config.provider,
    pickerLabel: advancedMode ? config?.ui?.advancedPickerLabel || config?.ui?.pickerLabel || config.label : config?.ui?.pickerLabel || config.label,
    pickerDescription: config?.ui?.pickerDescription || '',
    contextWindowTokens: targetConfig?.contextWindowTokens ?? null,
    attributes: config.attributes || null
  };
};

export default getModelOptionById;
